import { useTranslation } from "next-i18next"

const useCarouselSlicki18n = () => {
  const { t } = useTranslation()
  const i18n = {
    emptyCarouselListMsg: t("kf.carousel.label.emptyCarouselListMsg"),
  }

  return i18n
}

export default useCarouselSlicki18n
